import { observer } from 'mobx-react'
import { FC } from 'react'
import TransactionList from './TransactionList'
import useTransactions from '../../../hooks/api/useTransactions'
import { isTransactionOpen } from 'src/services/transactions/status'

const Transactions_open: FC<unknown> = () => {
  const hook = useTransactions(true)
  const { data: transactionsPayload } = hook

  const openTransactions = transactionsPayload?.data.filter(isTransactionOpen)
  return (
    <TransactionList
      {...hook}
      transactions={openTransactions || []}
      withMutationOptions={true}
    />
  )
}

export default observer(Transactions_open)
